import { render, staticRenderFns } from "./user_cwgl.vue?vue&type=template&id=23042d2b&scoped=true"
import script from "./user_cwgl.vue?vue&type=script&lang=js"
export * from "./user_cwgl.vue?vue&type=script&lang=js"
import style0 from "./user_cwgl.vue?vue&type=style&index=0&id=23042d2b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23042d2b",
  null
  
)

export default component.exports